import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store } from "../context/store";
import FadeLoader from "react-spinners/FadeLoader";
import apiRequest from "../utils/apiRequest";

function PropertyListing() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [propertyData, setProperies] = useState([]);
  let [loading, setLoading] = useState(false);
  let [, setError] = useState("");

  useEffect(() => {
    const loadProperties = async () => {
      setLoading(true);
      try {
        const url = `${baseUrl}/3properties`;
        const { data } = await apiRequest(url, "GET", null, null);
        setProperies(data.properties);
      } catch (error) {
        setError("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadProperties();
  }, [baseUrl]);

  return (
    <>
      {/*  Property List Start  */}
      <section className="container-xxl py-5 properties-section">
        <div className="container">
          <div className="row g-0 gx-5 align-items-end">
            <div className="col-lg-6">
              <div
                className="text-start mx-auto mb-5 wow slideInLeft properties-intro"
                data-wow-delay="0.1s"
              >
                <span className="properties-kicker">Featured homes</span>
                <h2 className="mb-3">Property Listing</h2>
                <p className="mb-0">
                  Discover your dream home with our comprehensive Property
                  Listing.
                </p>
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <FadeLoader color="#0078e7" />
                </div>
              ) : (
                <div className="row g-4">
                  {propertyData?.length === 0 ? (
                    <div>
                      <h3 className="text-center">No Property Available.</h3>
                    </div>
                  ) : (
                    propertyData?.map((e, i) => {
                      return (
                        <div
                          className="col-lg-4 col-md-6 wow fadeInUp"
                          data-wow-delay="0.1s"
                          key={i}
                        >
                          <Link
                            to={`/property/${e.id}`}
                            className="property-card-link"
                          >
                            <article className="property-item property-card-modern rounded overflow-hidden h-100">
                              <div className="position-relative overflow-hidden img-fluid-fixed property-media">
                                <img
                                  className="img-fluid"
                                  src={e.images[0]}
                                  alt={e.title}
                                />
                                <div className="property-badge status-badge">
                                  {e.status}
                                </div>
                              </div>
                              <div className="p-4">
                                <h5 className="d-block h5 property-title mb-2">
                                  {e.title}
                                </h5>
                                <p className="property-address mb-3">
                                  <i className="fa fa-map-marker-alt text-dark me-2"></i>
                                  {e.address}
                                </p>
                                <span className="property-view-more">
                                  View details{" "}
                                  <i className="fa fa-arrow-right ms-2"></i>
                                </span>
                              </div>
                            </article>
                          </Link>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
            </div>

            <div
              className="wow fadeInUp"
              data-wow-delay="0.1s"
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Link to="/properties" className="btn btn-primary py-3 px-4 mt-5">
                See More
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/*  Property List End  */}
    </>
  );
}

export default PropertyListing;
